import { useState } from "react";
import {
  Box,
  Select,
  MenuItem,
  FormControl,
  FormHelperText,
  Alert,
  Grid,
  Stack,
  Paper,
  IconButton,
} from "@mui/material";
import { Delete } from "@mui/icons-material";
import CommonDialog from "../../../components/CommonDialog";

const EditLanguageModal = (props) => {
  // modal states
  const [localLangData, setLocalLangData] = useState([
    ...props.employeeData?.languages,
  ]);
  const [validations, setValidations] = useState({});
  const [multipleVal, setMultipleVal] = useState({});
  // other functions
  const handleSubmit = () => {
    if (isFormValid()) {
      props.setOpen({ ...props.open, editLanguages: false });
      props.setEmployeeData((prevState) => {
        return {
          ...prevState,
          languages: [...localLangData],
        };
      });
    }
  };

  const isFormValid = () => {
    const data = localLangData.map((lang) => lang.id);
    if (data.length > [...new Set(data)].length) {
      setMultipleVal({
        status: true,
        msg: "A language cannot be present multiple times",
      });
      return false;
    }
    return true;
  };

  const handleDelete = (index) => {
    setLocalLangData((prevState) => {
      if (prevState.length === 1) {
        setValidations({
          status: true,
          msg: "Atleast one language is required",
        });
        return [...prevState];
      }
      prevState.splice(index, 1);
      return [...prevState];
    });
  };

  return (
    <CommonDialog
      open={props.open.editLanguages}
      title={"Edit Languages"}
      onSubmit={handleSubmit}
      onClose={() => props.setOpen({ ...props.open, editLanguages: false })}
    >
      <Paper style={{ ...props.style, width: "100%" }} elevation={0}>
        <Box sx={{ padding: "10px" }}>
          <Stack spacing={1}>
            {localLangData?.map((lang, index) => (
              <Grid container>
                <Grid xs={10} sm={10} md={10} lg={10} xl={10} item>
                  <FormControl
                    error={validations?.status}
                    sx={{ width: "100%" }}
                  >
                    <Select
                      variant="outlined"
                      size="small"
                      value={lang.id}
                      onChange={(e) => {
                        setLocalLangData((prevState) => {
                          const lang = props.languageOptions.filter(
                            (lang) => lang.id === e.target.value
                          );
                          prevState[index] = {
                            ...prevState[index],
                            ...lang[0],
                          };
                          return [...prevState];
                        });
                      }}
                      renderValue={(selected) => {
                        const selectedLang =
                          props.languageOptions.find(
                            (opt) => opt.id === selected
                          )?.name || "Unknown";
                        return selectedLang;
                      }}
                    >
                      {props.activeLanguages.map((lang) => (
                        <MenuItem value={lang.id}>{lang.name}</MenuItem>
                      ))}
                    </Select>
                    {validations?.status ? (
                      <FormHelperText>{validations?.msg}</FormHelperText>
                    ) : null}
                  </FormControl>
                </Grid>
                <Grid
                  xs={1}
                  sm={1}
                  md={1}
                  lg={1}
                  xl={1}
                  item
                  sx={{ textAlign: "right" }}
                >
                  <IconButton size="small" onClick={() => handleDelete(index)}>
                    <Delete color="error" />
                  </IconButton>
                </Grid>
              </Grid>
            ))}
            {multipleVal.status ? (
              <Alert severity="error">{multipleVal.msg || ""}</Alert>
            ) : null}
          </Stack>
        </Box>
      </Paper>
    </CommonDialog>
  );
};

export default EditLanguageModal;
